module.exports = __webpack_public_path__ + "img/online.b01444c0.svg";